import type { SignInSession } from '@/store/signInStore';

export type PIISafeClientAuthenticationSession = Omit<
  SignInSession,
  'identifier'
>;

export const getPIIFilteredSession = ({
  identifier: _,
  ...piiSession
}: SignInSession) => piiSession;
